import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { COLUNAS_PARCELAS, formatarValorColunaParcela } from './acordosController';
import * as C from '../../../theme/colors.constants';

/**
 * Accordion de parcelas de um acordo (AW2-1133 Etapa 4) — revelado pelo
 * chevron da grid "Acordos" (`TableAcordos.jsx`). Colunas fixas
 * (`COLUNAS_PARCELAS`, `acordosController.js`), header e corpo table-driven
 * sobre o MESMO array, mesmo padrão de `TableAcordos.jsx`.
 *
 * As 3 ações reais de parcela (Alterar/Enviar/Recibo) são só placeholder
 * visual nesta etapa — fora de escopo do AC da issue, que só fala das 7
 * ações do acordo + chevron, mesmo tratamento já dado às ações do acordo na
 * Etapa 3.
 */
const ACOES_PARCELA_PLACEHOLDER = [
  { Icone: EditOutlinedIcon, hint: 'Alterar Parcela' },
  { Icone: EmailOutlinedIcon, hint: 'Enviar Parcela' },
  { Icone: ReceiptOutlinedIcon, hint: 'Recibo' },
];

function AcoesParcelaPlaceholder() {
  return (
    <Box sx={{ display: 'flex', gap: 0, justifyContent: 'center' }}>
      {ACOES_PARCELA_PLACEHOLDER.map(({ Icone, hint }) => (
        <Tooltip key={hint} title={hint} arrow>
          <span>
            <IconButton size="small" disabled aria-label={hint} sx={{ color: C.navy, p: 0.4 }}>
              <Icone fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
}

export default function TableAcordoAccordion({ parcelas }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {COLUNAS_PARCELAS.map(coluna => (
            <TableCell key={coluna.campo} align={coluna.align}>{coluna.label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {parcelas.map(parcela => (
          <TableRow key={parcela.id ?? parcela.nroParcela} hover>
            {COLUNAS_PARCELAS.map(coluna => (
              <TableCell key={coluna.campo} align={coluna.align}>
                {coluna.campo === 'acoes'
                  ? <AcoesParcelaPlaceholder />
                  : formatarValorColunaParcela(coluna.campo, parcela)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

TableAcordoAccordion.propTypes = {
  parcelas: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    nroParcela: PropTypes.number,
    idTipoFormaPagto: PropTypes.number,
    dataVencimento: PropTypes.string,
    valor: PropTypes.number,
    idStatusParcelaAcordo: PropTypes.number,
  })),
};
TableAcordoAccordion.defaultProps = { parcelas: [] };
